export const MIN_PICS_FOR_INDICATOR = 2;
export const MAX_PAGES = 5;
export const DEBOUNCE_DELAY = 5;